module.exports = __webpack_public_path__ + "img/mediatheque_logo.96d407ad.svg";